<div class="row title">
	<div class="col-2">
		<div class="dashboard">Dashboard / Portfolio Data</div>
	</div>

	<div class="col-5">
		<div class="ss-searchbox">
			<i class="fa fa-search"></i>
			<input class="form-control"  style="background-color: #ECF0F1;" name="search" type="text" placeholder="Type Apartment Name,ID,Segment,Space,Variant ID,Preset Number to search" [(ngModel)]="searchstring" (keydown.enter)="getpage('')">
		</div>
	</div>
	<div class="col-3 filterColumn">
		<div [ngClass]="filterValue ? 'addedFilterStyle':'filterStyle'">
			<a class="whStyle" data-toggle="modal" data-target="#exampleModalLong2">
				<i class="fa fa-filter"  aria-hidden="true"></i>
			</a>
		</div>
		<div class="clearFilter" *ngIf ="filterValue">
			<span (click) = "removeAllFilter()" class="btn filterButtonsShowing"  >
				{{"Clear filter"}} <img src="../../../../../assets/img/cross-out.svg" class="ml-3" style="height: 10px;">
			</span>
		</div>
	</div>
	<div class="col-1 btnStyle">
		<p class="addbtn" (click)="tooltipHide()" [routerLink]="['/portfolio/create']" routerLinkActive='active'><i class="fa fa-plus"  aria-hidden="true"></i></p> 
	</div>
</div>
<div class="row body_height justify-content-center">
	<div class="col-12" *ngIf="erroralert">
		<div class="alert-box grid-100" *ngIf="errorMessage">
			<div class="alert alert-danger mt-3 text-center"> <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a> {{errorMessage}} </div>
		</div>
	</div>
	<div class="col-12" *ngIf="successalert">
		<div class="alert-box grid-100" *ngIf="successMessage">
			<div class="alert alert-success mt-3 text-center"> <a class="close link" data-dismiss="alert" (click)="successalert=false">×</a> {{successMessage}} </div>
		</div>
	</div>

	<div class="col-12 table-responsive p-0" id="scrollTop">
		<h5 *ngIf="portfolio.length === 0 " class="text-center " style="margin-top:15.5rem"> No portfolios Available</h5>
	</div>

	<ng-container *ngIf="portfolio.length > 0">
		<!-- For Portfolio header list -->
		<div class="row cardHeaderRow">
			<div class="col-1 cardColumn">
				Active/In-Active
			</div>
			<div class="col-1 cardColumn">
				ID
			</div>
			<div class="col-2 cardColumn">
				Image
			</div>
			<div class="col-3 cardColumn">
				Apartment Name, Format & Variant ID
			</div>
			<div class="col-1 cardColumn">
				Segment
			</div>
			<div class="col-1 cardColumn">
				Space
			</div>
			<div class="col-2 cardColumn">
				Price
			</div>
			<div class="col-1 cardColumn2">
				Action
			</div>
		</div>
		<!-- For Portfolio header list -->

		<!-- For Portfolio column list -->
		<ng-container *ngFor="let data of portfolio |  paginate: { itemsPerPage:10,currentPage: current_page,totalItems: total_page };let i = index" [attr.data-index]="i">
			<div class="row cardColRow">
				<div class="col-1 cardList">
					<input class="activeStyle" [checked] = "data.status" type="checkbox" (change) ="updateStatus($event, data.id)">
				</div>
				<div class="col-1 cardList">
					<div class="idStyle">{{"("+data.id+")"}}</div>
				</div>
				<div class="col-2 cardList">
					<img class="imgStyle" src="{{data.attachment_file}}" onerror="src='../../../assets/img/default-apartment.png'"  *ngIf="data.attachment_file !='/images/original/missing.png' ">
					<img src="{{data.secondary_image[0]}}" class="imgStyle" *ngIf="data.attachment_file =='/images/original/missing.png' "> 
				</div>
				<div class="col-3 cardList">
					<div *ngIf="!data.apartment.length> 0" class="text-center">-</div>
					<div class="appartmentStyle" *ngIf="data.apartment.length > 0" >Apartment Name-{{data.apartment[0].apartment_name}}<br>
						Format-{{data.apartment[0].format}}<br>
						Variant ID-{{data.apartment[0].variant_id}}
					</div>
				</div>
				<div class="col-1 cardList">
					<div class="appartmentStyle">{{data.segment}}</div>
				</div>
				<div class="col-1 cardList">
					<div class="appartmentStyle">{{data.space}}</div>
				</div>
				<div class="col-2 cardList">
					<div class="appartmentStyle">{{data.price_cents}}</div>
				</div>
				<div class="col-1 cardList2">
					<div class="col-12">
						<a data-toggle="modal" data-target="#exampleModalLong" style="cursor: pointer;" (click)="getPortfolio(data.id)">
							<i data-toggle="tooltip" title="Edit" data-placement="top" class="fa fa-pencil-square-o" aria-hidden="true"></i>
						</a>
					</div>
					<div class="col-12">
						<a (click)="confirmAndDelete(data.id)" style="cursor: pointer;">
							<i data-toggle="tooltip" title="Delete" data-placement="top" class="fa fa-trash" aria-hidden="true"></i>
						</a>
						<div class="alert alert-warning my-2" *ngIf="(data.attachment_size/1024) > 120"> <strong>Warning!</strong> Image size exceeds 120kb. </div>
					</div>
				</div>
			</div>
		</ng-container>
		<!-- For Portfolio column list -->
	</ng-container>

	<!-- <div class="col-12 table-responsive p-0" id="scrollTop">

		<h5 *ngIf="portfolio.length === 0 " class="text-center " style="margin-top:15.5rem"> No portfolios Available</h5>
		<table *ngIf="portfolio.length > 0" class="table table-hover">
			<thead>
				<tr>
					<th class="text-center">ID</th>
					<th class="text-center">Segment</th>
					<th class="text-center">Space</th>
					<th class="text-center">Apartment Name,<br>Format & Variant ID</th>
					<th class="text-center">Price</th>
					<th class="table_img_col text-center">Image</th>
					<th class="table_active_col text-center">Actions</th>
					<th class="table_active_col text-center">Active/In-Active</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let data of portfolio |  paginate: { itemsPerPage:10,currentPage: current_page,totalItems: total_page };let i = index" [attr.data-index]="i">
					<td class="text-center">{{data.id}}</td>
					<td class="text-center">{{data.segment}}</td>
					<td class="text-center">{{data.space}}</td>
					<td *ngIf="!data.apartment.length> 0" class="text-center">-</td>
					<td *ngIf="data.apartment.length > 0" >Apartment Name-{{data.apartment[0].apartment_name}}<br>
						Format-{{data.apartment[0].format}}<br>
						Variant ID-{{data.apartment[0].variant_id}}</td>
					<td>{{data.price_cents}}</td>
					<td> 
						<img class="my-2 img-fluid" src="{{data.attachment_file}}" onerror="src='../../../assets/img/default-apartment.png'"  *ngIf="data.attachment_file !='/images/original/missing.png' ">
						<img src="{{data.secondary_image[0]}}" class="img-fluid" *ngIf="data.attachment_file =='/images/original/missing.png' "> 
					</td>
					<td class="text-center fa_icons">
						<a data-toggle="modal" data-target="#exampleModalLong" (click)="getPortfolio(data.id)">
							<i data-toggle="tooltip" title="Edit" data-placement="top" class="fa fa-pencil" aria-hidden="true"></i>
						</a>
						<a (click)="confirmAndDelete(data.id)">
							<i data-toggle="tooltip" title="Delete" data-placement="top" class="fa fa-trash" aria-hidden="true"></i>
						</a>
						<div class="alert alert-warning my-2" *ngIf="(data.attachment_size/1024) > 120"> <strong>Warning!</strong> Image size exceeds 120kb. </div>
						
					</td>
					<td>
						<input [checked] = "data.status" type="checkbox" (change) ="updateStatus($event, data.id)">
					</td>
				</tr>
			</tbody>

		</table>
	
		</div> -->
		<div class="paginationMr" *ngIf="portfolio.length > 0">
		<pagination-controls  autoHide="true" (pageChange)="current_page = getpage($event)"  previousLabel="PREV"
		nextLabel="NEXT" class="float-right"></pagination-controls>
		</div> 
	
	</div>
	

<div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
	<div class="modal-dialog updateDialog" role="document">
		<div class="modal-content">
			<form (ngSubmit)="onSubmit(editPortfolioForm.value); editPortfolioForm.reset();" #editPortfolioForm="ngForm">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLongTitle">Update Portfolio Details</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Segment<span class="astric">*</span></label>
								<select class="form-control" name="segment" [(ngModel)]="segment" (change)="firstDropDownChanged($event.target.value)">
									<option value="" disabled>Select Segment</option>
									<option value="Home" [selected]="segment == 'Home'">Home</option>
									<option value="Office" [selected]="segment == 'Office'">Office</option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Space<span class="astric">*</span></label>
								<select class="form-control" name="space" [(ngModel)]="space" (change)="spaceDropDownChanged($event.target.value)">
									<option value="" disabled>Select Space</option>
									<option *ngFor="let v of spaces" value="{{v}}" [selected]="space == v"> {{v}} </option>
								</select>
							</div>
						</div>
						<div class="col-md-6" *ngIf="segment=='Home' && (space == 'Living' || space == 'Kitchen' || space == 'Kids Room' || 'Master bedroom' || 'Guest Bedroom' || 'Dining Room' || 'All Spaces' )">
							<div class="form-group label-floating">
								<label class="control-label"> Theme<span class="astric">*</span></label>
								<select class="form-control" name="theme" [(ngModel)]="theme">
									<option value="" disabled>Select Theme</option>
									<option *ngFor="let v of themes" value="{{v}}" [selected]="theme == v"> {{v}} </option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Lifestage<span class="astric">*</span></label>
								<select class="form-control text-capitalize" name="lifestage" [(ngModel)]="lifestage" (change)="selectLifeStage($event.target.value)">
									<option value="" disabled>Select Lifestage</option>
									<option *ngFor="let v of lifestages" value="{{v.name}}" [selected]="lifestage == v.name"> {{transform(v.name)}} </option>
								</select>
							</div>
						</div>
						<div class="col-md-6" *ngIf="segment=='Home' && space == 'Bedroom' ">
							<div class="form-group label-floating">
								<label class="control-label"> Element</label>
								<select class="form-control" name="element" [(ngModel)]="element">
									<option value="" disabled>Select Element</option>
									<option *ngFor="let v of elements" value="{{v}}" [selected]="element == v"> {{v}} </option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> EMI</label>
								<input type="number" class="form-control" name="price_cents" [(ngModel)]="price_cents" min=0> </div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> User Story Title</label>
								<input type="text" class="form-control" name="user_story_title" [(ngModel)]="user_story_title"> </div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Preset Number</label>
								<input type="text" placeholder="Enter Preset Number" class="form-control" name="preset_number" [(ngModel)]="preset_number"> </div>
						</div>
						<!--Preset Type-->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Preset Type</label>
								<select class="form-control" name="preset_type" [(ngModel)]="preset_type">
									<option value="" disabled>Select Preset Type</option>
									<option value="Basic">Basic</option>
									<option value="Advanced">Advanced</option>
									<option value="Plus">Plus</option>
								</select>
							</div>
						</div>
						<!-- preset Name -->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Preset Name<span class="astric">*</span></label>
								<input type="text" class="form-control" placeholder="Enter Preset Name" name="preset_name" [(ngModel)]="preset_name"> </div>
						</div>
						<!--Space Area-->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Space Area</label>
								<input type="text" class="form-control" placeholder="Enter Space Area" name="space_area" [(ngModel)]="space_area"> </div>
						</div>

						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Select Shape</label>
								<select class="form-control" name="space_shape" [(ngModel)]="space_shape">
									<option value="">Select Space</option>
									<option *ngFor="let v of differentShapes" value="{{v.value}}" [selected]="space_shape == v.value"> {{v.name}} </option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating" >
								<p>Featured</p>
							   <div class="d-flex">
								<div class="form-check">
									<input (change) ="onItemChange($event.target.value)"   [value]="true" type="radio" name="exampleRadios" id="exampleRadios1" value="checkyes" [checked] = "is_featured">
									<label class="form-check-label pl-0" for="exampleRadios1">
									  Yes
									</label>
								</div>
								<div class="form-check pl-5">
									<input (change) ="onItemChange($event.target.value)"  [value] ="false"  type="radio" name="exampleRadios" id="exampleRadios2" value="checkno" [checked] = "!is_featured">
									<label class="form-check-label pl-0" for="exampleRadios2">
									  No
									</label>
								</div>
							   </div>
							</div>
						</div>
						<!--City-->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Selected City</label>
								<ng-select placeholder="Search For City" class="" name="city" [(ngModel)]="city" (change)="getscityList($event)" (keyup)="searchCity($event)">
									<ng-option *ngFor="let city of city_list" [value]="city.name">{{ city.name | titlecase }}</ng-option>
								</ng-select>
							</div>
						</div>
            <!--Apartment Name-->
            <!-- <ng-container *ngIf="societyList && societyList.length > 0"> -->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Selected Apartment</label>
								<ng-select placeholder="Search For Apartment" class="" name="apartment_name" [(ngModel)]="apartment_name" (change)='getselectedbuilding($event)' (keyup)="searchSociety($event)">
									<ng-option *ngFor="let build of societyList" [value]="build.attributes.unid">{{ build.attributes.apartment_name }}</ng-option>
								</ng-select>
							</div>
            </div>
            <!-- </ng-container> -->
            <!--Select flat-type/size-->
            <!-- <ng-container *ngIf="societyList && societyList.length > 0"> -->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Selected Flat Type/ Size</label>
								<ng-select placeholder="Select Flat-Type" class="" name="format" [(ngModel)]="format" (change)="getselectedbuildingtypes($event)">
									<ng-option *ngFor="let types of flatsize" [value]="types">{{ types }}</ng-option>
								</ng-select>
							</div>
            </div>
            <!-- </ng-container> -->
            <!--Select Varient-->
            <!-- <ng-container *ngIf="societyList && societyList.length > 0"> -->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Selected Variant</label>
								<ng-select placeholder="Selecte Variant" class="" name="variant_id" [(ngModel)]="variant_id" (change)="isAllVarient($event)">
									<ng-option *ngFor="let types of varientId" [value]="types.id">{{ types.variant_id }}</ng-option>
								</ng-select>
							</div>
            </div>
			
            <!-- </ng-container> -->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> BOQ Number</label>
								<!-- <input type="text" class="form-control" name="boq_number" [(ngModel)]="boq_number"> -->
								<ng-select placeholder="Search and Select BOQ" class="" name="boq_number" [(ngModel)]="boq_number" (change)="getsBOQnumber($event)" (keyup)="searchBOQ($event)">
									<ng-option *ngFor="let build of boq_dropdown" [value]="build.reference_number">{{ build.reference_number }}</ng-option>
								</ng-select>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Description</label>
								<textarea rows="5" class="form-control" name="description" [(ngModel)]="description"></textarea>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Portfolio Data</label>
								<textarea rows="5" class="form-control" name="portfolio_data" [(ngModel)]="portfolio_data"></textarea>
							</div>
						</div>
						<!-- <div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Change Top-Down Image<span class="astric">(Single Image Upload is allowed)</span></label>
								<input type="file" class="form-control" (change)="onChange($event)" name="attachment_file" ngModel #attachment_file="ngModel"> </div> 
								<img src="{{imgsrc}}" id="updateimgsrc" height="300px" width="100%" *ngIf="imgsrc != '/images/original/missing.png'"/>
								<img src="../../../../assets/v3/img/noimgicon.jpeg" height="300px" width="100%" *ngIf="imgsrc =='/images/original/missing.png'">
						</div> -->
						<div class="col-md-6">
							<div class="form-group label-floating inputStyle">
								<label class="control-label labelStyle">Change Top-Down Image<span class="astric1">(Single Image is
										Allowed)</span></label>
								<input type="file" class="form-control border-0" (change)="onChange($event)"
									name="attachment_file" [attr.id]="'attachment_file1'" formControlName="attachment_file" hidden>
									<div class="col-md-12 uploadStyle">
										<div class="col-md-7 imgStyle1">{{'Update Image'}}</div>
										<div class="col-md-4 uploadBtn">
											<label class="labelStyle2" for="{{'attachment_file1'}}">Upload</label>
										</div>
									</div>
							</div>
							<!-- <ng-container *ngIf="fileName?.length > 0">
								<div class="col-md-12 previeHeadStyle pl-0">
									<div class="col-8 pl-0">
										<img src="{{basefile}}" height="31px" width="31px">
										<span class="ml-2 maxImgStyle">{{fileName}}</span>
										<span class="ml-2 maxPrevStyle"><a href="{{basefile}}" class="maxPrevStyle" target="_blank" style="cursor: pointer;">Preview</a></span>
									</div>
									<div class="col-4 cancelStyle">
										<span class="ml-2 fileSizeStyle" (click)="onCancelSingleImages(i)"><i class="fa fa-close" style="color: rgba(0, 0, 0, 0.7); font-size:10px; cursor: pointer;"></i></span>
									</div>
								</div>
							</ng-container>
							<ng-container *ngIf="imgsrc?.length > 0 && !this.fileName">
								<div class="col-md-12 previeHeadStyle pl-0">
									<div class="col-8 pl-0">
										<img src="{{imgsrc}}" height="31px" width="31px" *ngIf="imgsrc != '/images/original/missing.png'">
										<img src="../../../../assets/v3/img/noimgicon.jpeg" height="31px" width="31px" *ngIf="imgsrc =='/images/original/missing.png'">
										<span class="ml-2 maxImgStyle">{{"Image1"}}</span>
										<span class="ml-2 maxPrevStyle"><a href="{{imgsrc}}" class="maxPrevStyle" target="_blank" style="cursor: pointer;">Preview</a></span>
									</div>
									<div class="col-4 cancelStyle" *ngIf="imgsrc">
										<span class="ml-2 fileSizeStyle" (click)="onCancelSingleImages()"><i class="fa fa-close" style="color: rgba(0, 0, 0, 0.7); font-size:10px; cursor: pointer;"></i></span>
									</div>
								</div>
							</ng-container> -->
							<ng-container *ngIf="cancelTopDownImage">
								<div class="col-md-12 previeHeadStyle pl-0">
									<div class="col-8 pl-0">
										<img *ngIf="imgsrc !==  '/images/original/missing.png'" src="{{imgsrc}}" height="31px" width="31px">
										<span *ngIf = "fileName && imgsrc !==  '/images/original/missing.png' " class="ml-2 maxImgStyle">{{fileName}}</span>
										<span *ngIf ="imgsrc !==  '/images/original/missing.png' && showAndHidePreviewTopDownImage " class="ml-2 maxPrevStyle"><a href="{{imgsrc}}" class="maxPrevStyle" target="_blank" style="cursor: pointer;">Preview</a></span>
									</div>
									<div class="col-4 cancelStyle" *ngIf="imgsrc !==  '/images/original/missing.png'">
										<span class="ml-2 fileSizeStyle" (click)="onCancelSingleImages()"><i class="fa fa-close" style="color: rgba(0, 0, 0, 0.7); font-size:10px; cursor: pointer;"></i></span>
									</div>
								</div>
							</ng-container>
						</div>
						<!-- <div class="col-md-12">
							<div class="form-group label-floating">
								<label class="control-label">Change Other Images:- <span class="astric">(Multiple Image Upload Allows Max 5 images)*</span></label>
								<ng-container *ngFor="let data of secondaryImage; let i=index">
									<a [href]="data.attributes.document" class="ml-4" target="_blank" style="color: #8d0528; text-decoration: none;">Image {{ i+1}}</a>
									<span (click)="deleteContent(data.attributes.id)" style="color: #8d0528; text-decoration: none;">(Delete)</span>
									</ng-container>
									<input type="file" class="form-control" (change)="onChangeSecondary($event)" name="attachment_file_secondary" ngModel #attachment_file_secondaryi="ngModel">
								
								</div>
						</div>	 -->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label labelStyle">Change Other Images<span class="astric1">(Max 5 Images are
										Allowed)</span><span class="astric">*</span></label>
								<input type="file" multiple="" [attr.id]="'attachment_files2'" class="form-control border-0" (change)="onChangeSecondary($event)"
									name="contents" formControlName="contents" hidden>
								<div class="col-md-12 uploadStyle">
									<div class="col-md-7">
										<ng-container>
											<div class="imgStyle1">
												Upload Image
											</div>
										</ng-container>
									</div>
									<div class="col-md-4 uploadBtn">
										<label class="labelStyle2" for="{{'attachment_files2'}}">Upload</label>
									</div>
								</div>
							</div>
							<ng-container *ngIf="imageName?.length > 0">
								<ng-container *ngFor="let data of attachement_files;let i = index">
									<div class="col-md-12 previeHeadStyle pl-0">
										<div class="col-8 pl-0">
											<img [src]="data" height="31px" width="31px">
											<span class="ml-2 maxImgStyle">{{imageName[i].name}}</span>
											<!-- <span class="ml-2 maxPrevStyle"><a [href]="data" target="_blank" class="maxPrevStyle" style="cursor: pointer;">Preview</a></span> -->
										</div>
										<div class="col-4 cancelStyle">
											<!-- <span class="fileSizeStyle">{{"Default"}}</span> -->
											<span id="manulal" class="ml-2 fileSizeStyle" (click)="onMultiCancelImg(i)"><i class="fa fa-close" style="color: rgba(0, 0, 0, 0.7); font-size:10px; cursor: pointer;"></i></span>
										</div>
									</div>
								</ng-container>	
							</ng-container>
	
							<ng-container *ngFor="let data of secondaryImage;let i = index">
								<div class="col-md-12 previeHeadStyle pl-0">
									<div class="col-8 pl-0">
										<img [src]="data.attributes.document" height="31px" width="31px">
										<span class="ml-2 maxImgStyle">Image {{ i+1}}</span>
										<span  class="ml-2 maxPrevStyle"><a [href]="data.attributes.document" target="_blank" class="maxPrevStyle" style="cursor: pointer;">Preview</a></span>
									</div>
									<div class="col-4 cancelStyle">
										<!-- <span class="fileSizeStyle">{{"Default"}}</span> -->
										<span id="api" class="ml-2 fileSizeStyle" (click)="deleteContent(data.attributes.id)"><i class="fa fa-close" style="color: rgba(0, 0, 0, 0.7); font-size:10px; cursor: pointer;"></i></span>
									</div>
								</div>
							</ng-container>	
						</div>

						<!-- <div class="col-md-6">
							<div class="form-group label-floating mb-0">
								<label class="control-label">Update Preset File</label>
									<input type="file" class="form-control" id="presetfileupload" (change)="onImagePicked($event)" accept=".zip,.rar,.7zip" name="design_file" ngModel  #design_file = "ngModel">
									<span class="astric">{{errormsgpresetfile}}</span>
							</div>
							<span *ngIf = "checkPresetfile && checkPresetfile !== '' && checkPresetfile !=='/images/original/missing.png' ">
								<span class="astric cursor-pointer"> {{presetfileName | replaceChar }}</span>
									
									<img *ngIf ="checkpresetfileuploda && filedelete== 'ongetdata' " (click) = "deletepresetfile()" class="ml-2 cursor-pointer" src="../../../../../assets/img/close.png">
									<span class="astric" *ngIf ="filedelete == 'deletefile'">(Once we click on update,file will be deleted)</span>
							</span>
						</div>	 -->

						<div class="col-md-6">
							<p class="mb-2 labelStyle">Update Preset File</p>
							<div class="input-group">
								<input id="presetfileupload"   class="form-control preset-zip-file-upload" readonly (click)="filePicker.click()"  name="design_file" ngModel  #design_file = "ngModel" >
								<div class="input-group-append">
								<button class="btn cursor-pointer btn-burgntee px-4 font-weight-bold choose-file-btn" (click)="filePicker.click()" type="button">Choose File</button>
								</div>
								<input name="design_file" ngModel  #design_file = "ngModel"   #filePicker (change) = "onImagePicked($event)" type="file"  accept=".zip,.rar,.7zip" class="form-control-file d-none" >
							</div>
							<span class="astric">{{errormsgpresetfile}}</span>
							<span class="astric cursor-pointer"> {{presetfileName | replaceChar }}</span>
							<span *ngIf = "checkPresetfile && checkPresetfile !== '' && checkPresetfile !=='/images/original/missing.png' ">
									<img *ngIf ="checkpresetfileuploda && filedelete== 'ongetdata' " (click) = "deletepresetfile()" class="ml-2 cursor-pointer" src="../../../../../assets/img/close.png">
									<span class="astric" *ngIf ="filedelete == 'deletefile'">(Once we click on update,file will be deleted)</span>
							</span>
						</div>
						<!-- <div class="col-md-6">
							<p class="mb-2 labelStyle">Update Preset File</p>
							<div class="input-group">
								<input id="presetfileupload"   class="form-control preset-zip-file-upload" readonly (click)="filePicker.click()"  formControlName="design_file"  aria-label="Recipient's username" aria-describedby="basic-addon2">
								<div class="input-group-append">
								<button class="btn cursor-pointer btn-burgntee px-4 font-weight-bold choose-file-btn" (click)="filePicker.click()" type="button">Choose File</button>
								</div>
								<input  #filePicker (change) = "onImagePicked($event)" type="file"  accept=".zip,.rar,.7zip" class="form-control-file d-none" >
							</div>
							
							<ng-container *ngIf="namepresetfile?.length > 0 && (checkPresetfile == '' || checkPresetfile =='/images/original/missing.png')">
								<div class="col-md-12 previeHeadStyle pl-0">
									<div class="col-8 pl-0">
										<span class="ml-2 maxImgStyle">{{namepresetfile}}</span>
									</div>
									<div class="col-4 cancelStyle">
										<span class="ml-2 fileSizeStyle" (click)="onCancelPresetFile()"><i class="fa fa-close" style="color: rgba(0, 0, 0, 0.7); font-size:10px; cursor: pointer;"></i></span>
									</div>
								</div>
							</ng-container>	
							<ng-container *ngIf="!namepresetfile && checkPresetfile && checkPresetfile !== '' && checkPresetfile !=='/images/original/missing.png'">
								<div class="col-md-12 previeHeadStyle pl-0">
									<div class="col-4 pl-0">
										<span class="ml-2 maxImgStyle">{{presetfileName | replaceChar }}</span>
									</div>
									<div class="col-8 cancelStyle">
										<span class="astric" *ngIf ="filedelete == 'deletefile'">(Once we click on update,file will be deleted)</span>
										<span class="ml-2 fileSizeStyle" *ngIf ="checkpresetfileuploda && filedelete== 'ongetdata' " (click) = "deletepresetfile()"><i class="fa fa-close" style="color: rgba(0, 0, 0, 0.7); font-size:10px; cursor: pointer;"></i></span>
									</div>
								</div>
							</ng-container>	
						</div> -->

						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> BOQ Value</label>
								<input type="text" class="form-control" disabled name="boq_value" [(ngModel)]="boq_value"> </div>
						</div>

						<div class="col-md-12 mt-5">
							<div class="form-group label-floating">
								<p>Space item selected:</p>
								<ul class="ks-cboxtags" id="myUL">
									<li *ngFor="let item of space_item;let j = index"> <span>
                              <input type="checkbox" id="{{item.item_name+j}}"
                                 value="{{item.id}}" (change)="isAllSelected($event,j)" checked>
                              <label class="text-capitalize" for="{{item.item_name+j}}">{{item.item_name}}</label>
                            </span>
										<!-- <span *ngIf="!leadItemscheckedListNames.includes(item.name.toLowerCase())">
                              <input type="checkbox" id="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}"
                                (change)="isAllSelected($event)" value="{{item.name}}">
                              <label for="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}">{{item.name}}</label>
                            </span> --></li>
								</ul>
								<ul class="ks-cboxtags" id="myUL">
									<li *ngFor="let item of other_space_item;let j = index"> <span>
                                    <input type="checkbox" id="{{item.item_name+j}}"
                                       value="{{item.id}}" (change)="isAllSelected($event,j)">
                                    <label class="text-capitalize" for="{{item.item_name+j}}">{{item.item_name}}</label>
                                  </span>
										<!-- <span *ngIf="!leadItemscheckedListNames.includes(item.name.toLowerCase())">
                                    <input type="checkbox" id="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}"
                                      (change)="isAllSelected($event)" value="{{item.name}}">
                                    <label for="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}">{{item.name}}</label>
                                  </span> --></li>
								</ul>
							</div>
						</div>

						

					</div>
				</div>
				<div class="modal-footer footerStyle">
					<!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
					<button type="submit" [disabled] = "checkfileSizeMb || validateButton()"  class="button updateStyle">Update</button>
				</div>
			</form>
		</div>
	</div>
</div>

<div class="modal fade" id="exampleModalLong2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLong2Title" aria-hidden="true">
	<div class="modal-dialog filterModal" role="document">
		<div class="modal-content modalStyle">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLong2Title">Add Filters</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-12 lstColStyle">
						<div class="row mainCardStyle">
							<div class="col-md-3 apply_border_bottom_filters">
								<div class="d-flex justify-content-between px-3 mt-2 cursor-pointer" (click) ="showHideForFilters('state')">
									<p class="font-weight-bold colorBurguntee">Status</p>
									<i *ngIf = "!showhideforstateFilter" class="fa fa-angle-down"></i>
									<i *ngIf = "showhideforstateFilter" class="fa fa-angle-up"></i>
								</div>
								<div  [ngClass] = "!showhideforstateFilter ? 'd-block' : 'd-none'">
									<div *ngFor="let item of updated_stateName; let i = index" class="d-flex px-3">
										<span>
											<input class="activeStyle" name="statusactiveinactive" (click) ="stateFilterUpdated($event,item.name, item.id, item.value)" type="radio" id="stateCheckbox{{ item.id }}">

										</span>
										<p class="ml-2">{{item.name | replaceChar}}</p>
									</div>
								</div>
							</div>

							<div class="col-md-3 apply_border_bottom_filters">
								<div class="d-flex justify-content-between px-3 mt-2 cursor-pointer" (click) ="showHideForFilters('segment')">
									<p class="font-weight-bold colorBurguntee">Segment</p>
									<i *ngIf = "!showhideforsegmentFilter" class="fa fa-angle-down"></i>
									<i *ngIf = "showhideforsegmentFilter" class="fa fa-angle-up"></i>
								</div>
								<div  [ngClass] = "!showhideforsegmentFilter ? 'd-block' : 'd-none'">
									<div *ngFor="let item of updated_segmentName; let i = index" class="d-flex px-3">
										<span>
											<input class="activeStyle" (click) ="segmentFilterUpdated($event,item.name, item.id)" type="checkbox" id="segmentCheckbox{{ item.id }}">
										</span>
										<p class="ml-2">{{item.name | replaceChar}}</p>
									</div>
								</div>
							</div>

							<div class="col-md-3 apply_border_bottom_filters">
								<div class="d-flex justify-content-between px-3 mt-2 cursor-pointer" (click) ="showHideForFilters('space')">
									<p class="font-weight-bold colorBurguntee">Space</p>
									<i *ngIf = "!showhideforSpaceFilter" class="fa fa-angle-down"></i>
									<i *ngIf = "showhideforSpaceFilter" class="fa fa-angle-up"></i>
								</div>
								<div  [ngClass] = "!showhideforSpaceFilter ? 'd-block' : 'd-none'">
									<div *ngFor="let item of updated_spaceName; let i = index" class="d-flex px-3">
										<ng-container *ngIf ="i <= 4">
											<span>
												<input class="activeStyle" (click) ="spaceFilterUpdated($event,item.name, item.id)" type="checkbox" id="spaceCheckbox{{ item.id }}">
											</span>
											<p class="ml-2">{{item.name | replaceChar}}</p>
										</ng-container>
										<div [ngClass] = "i > 4 && plusMoreBoolean ? 'd-flex' : 'd-none'">
											<span>
												<input class="activeStyle" (click) ="spaceFilterUpdated($event,item.name, item.id)" type="checkbox" id="spaceCheckbox{{ item.id }}">
											</span>
											<p class="ml-2">{{item.name | replaceChar}}</p>
										</div>
									</div>
									<p style="margin-left: 2.1rem;" (click) = "plusMore('space')" class="cursor-pointer colorBurguntee">{{!plusMoreBoolean ? '+2 More' : '-Show Less'}}</p>
								</div>
							</div>

							<div class="col-md-3 apply_border_bottom_filters">
								<div class="d-flex justify-content-between px-3 mt-2 cursor-pointer" (click) ="showHideForFilters('price')">
									<p class="font-weight-bold colorBurguntee">Price</p>
									<i *ngIf = "!showhideforpriceFilter" class="fa fa-angle-down"></i>
									<i *ngIf = "showhideforpriceFilter" class="fa fa-angle-up"></i>
								</div>
								<div  [ngClass] = "!showhideforpriceFilter ? 'd-block' : 'd-none'">
									<div *ngFor="let item of updated_priceName; let i = index" class="d-flex px-3">
										<span>
											<input class="activeStyle" (click) ="priceFilterUpdated($event,item.name, item.id, item.paramvalue)" type="checkbox" id="priceCheckbox{{ item.id }}">
										</span>
										<p class="ml-2">{{item.name | replaceChar}}</p>
									</div>
								</div>
							</div>
							<!-- <div class="col-12 applyBtn">
								<button data-dismiss="modal" aria-label="Close" (click)="onApplyFilter()" class="close applyBtnStyle">Apply</button>
							</div> -->
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer footerStyle2">
				<button data-dismiss="modal" aria-label="Close" (click)="onApplyFilter()" class="close applyBtnStyle">Apply</button>
			</div>
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/portfolio/listportfoliodata/listportfoliodata.component.html